const scale = {
  minFreq: 20,
  maxFreq: 20000,
  sampleRate: 44100, // need to test 96000 in all browsers
  dbSteps: 4,
  maxGain: 12,
  minGain: -12
}

export default scale
